import { makeStyles } from 'vendor/material';
import VendorConfigSidebar from './VendorConfigSidebar';
import { FormProgressQueryResult } from '../../../../../utils/yup-extended';

const useStyles = makeStyles((theme) => ({
  listingMainContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  listingFormContainer: {
    width: '100%',
    marginRight: theme.spacing(3),
  },
  listingAlert: {
    marginBottom: theme.spacing(4),
  },
  listingAlertText: {
    fontSize: theme.typography.pxToRem(14),
  },
}));

const VendorConfigWrapper = ({
  children,
  cloudString,
  onAfterCompleted,
  progress,
}: {
  children: React.ReactNode;
  cloudString;
  onAfterCompleted: (cloud: string) => void;
  progress: FormProgressQueryResult;
}) => {
  const classes = useStyles();
  return (
    <div>
      <main className={classes.listingMainContainer}>
        <div className={classes.listingFormContainer}>{children}</div>
        <VendorConfigSidebar
          cloudString={cloudString}
          onAfterCompleted={onAfterCompleted}
          progress={progress}
        />
      </main>
    </div>
  );
};

export default VendorConfigWrapper;
